import {
  FETCH_SITE_SETTINGS
} from 'constants/actionTypes'

const INIT_STATE = {
  data: []
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_SITE_SETTINGS:
      let response = action.payload.data
      return {
        ...state,
        data: response
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./reducers/siteSettings.js